import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IonInput,
  IonList,
  IonItem,
  IonListHeader,
  IonButton,
  IonNote,
} from '@ionic/react';

const OPTIONS = [
  { label: '18% Tip', value: '18' },
  { label: '20% Tip', value: '20' },
  { label: '25% Tip', value: '25' },
  { label: 'Custom', value: 'custom' },
];

function Tip({
  option,
  setOption,
  value,
  setValue,
  automaticGratuity,
}) {
  const [showTip, setShowTip] = useState(false);
  const handleChangeValue = (e) => {
    setValue(e.target.value);
  };

  return (
    <IonList>
      {automaticGratuity && (
        <IonListHeader>
          <div className="automatic-gratuity">
            <div className="d-flex align-center">
              <span className="mr-1 font-bold">Automatic Gratuity</span>
              {!showTip && (
                <IonButton
                  color="tertiary"
                  fill="outline"
                  size="small"
                  type="button"
                  onClick={() => setShowTip(true)}
                >
                  Add Tip
                </IonButton>
              )}
            </div>
          </div>
        </IonListHeader>
      )}
      {automaticGratuity && (
        <IonItem lines="none">
          <IonNote>
            <small>
              This venue has automatic gratuity set up. If you wish to tip more
              than the amount shown, you can choose to add a custom tip amount.
            </small>
          </IonNote>
        </IonItem>
      )}
      {!automaticGratuity && (
        <section className="d-flex">
          {OPTIONS.map((opt) => (
            <IonButton
              key={opt.value}
              color={opt.value === option ? 'tertiary' : 'light'}
              onClick={() => setOption(opt.value)}
            >
              {opt.label}
            </IonButton>
          ))}
        </section>
      )}
      {(showTip || !automaticGratuity) && (
        <IonItem>
          <IonInput
            disabled={option !== 'custom' && !automaticGratuity}
            onIonChange={handleChangeValue}
            value={value}
            type="number"
            placeholder="Custom Tip Amount"
          />
        </IonItem>
      )}
    </IonList>
  );
}

Tip.propTypes = {
  automaticGratuity: PropTypes.bool,
  option: PropTypes.string,
  value: PropTypes.string,
  setOption: PropTypes.func,
  setValue: PropTypes.func,
};

export default Tip;
